/**
 * Model picker, pick-on-this-page mode.
 *
 * Linking each card to its own product page sends a customer who was ready to
 * buy off to a fresh page, where the visit can end. In this mode the card is a
 * choice instead: picking another model swaps what the product form adds, so
 * the customer never leaves.
 *
 * The theme's own `id` input is disabled rather than rewritten, because the
 * variant picker replaces that element wholesale when a variant changes; an
 * override input alongside it survives that, and the state is re-applied on
 * every variant change.
 */
if (!customElements.get('model-picker-select')) {
  class ModelPickerSelect extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section') || document;

      this.changeHandler = this.apply.bind(this);
      this.addEventListener('change', this.changeHandler);
      this.section.addEventListener('on:variant:change', this.changeHandler);

      this.apply();
    }

    disconnectedCallback() {
      this.section.removeEventListener('on:variant:change', this.changeHandler);
      this.clear();
    }

    get form() {
      return document.getElementById(this.dataset.formId);
    }

    /**
     * Removes the override and hands the form back to the theme.
     */
    clear() {
      const form = this.form;
      if (!form) return;
      form.querySelector('input[data-model-override]')?.remove();
      const themeInput = form.querySelector('input[name="id"]');
      if (themeInput) themeInput.disabled = false;
    }

    /**
     * Points the product form at whichever model is selected.
     */
    apply() {
      const form = this.form;
      if (!form) return;

      const checked = this.querySelector('.model-picker__input:checked');
      if (!checked || checked.dataset.modelCurrent === 'true') {
        this.clear();
        return;
      }

      const themeInput = form.querySelector('input[name="id"]:not([data-model-override])');
      if (themeInput) themeInput.disabled = true;

      let override = form.querySelector('input[data-model-override]');
      if (!override) {
        override = document.createElement('input');
        override.type = 'hidden';
        override.name = 'id';
        override.setAttribute('data-model-override', '');
        form.appendChild(override);
      }
      override.value = checked.value;
    }
  }

  customElements.define('model-picker-select', ModelPickerSelect);
}
